import angular from 'angular'
import './compatible_app.service'

angular
  .module('admin.compatible_apps', ['admin.compatible_apps.service'])
  .controller('CompatibleAppCtrl', CompatibleAppCtrl)

/** @ngInject */
function CompatibleAppCtrl(CompatibleAppService, UploadService) {
  var vm = this

  vm.items = []
  vm.perPage = 25

  vm.options = [
    { id: 1, name: 'Marketplace' },
    { id: 2, name: 'Metaverse' },
  ]

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    CompatibleAppService.list(vm.oldPage, 25).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
        if (result.results[i].k) {
          switch (result.results[i].k) {
            case 1:
              result.results[i].types = 'Marketplace'
              break
            case 2:
              result.results[i].types = 'Metaverse'
              break
            default:
              result.results[i].types = 'Unknown'
              break
          }
        }
      }
      vm.items = result.results
    })
  }

  load(1)

  vm.load = function() {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function() {
    vm.app = {
      id: 0,
      'img-i': '',
      t: '',
      txt: '',
      k: 0,
      'url-h': '',
      'url-pr': '',
      'url-ref': '',
    }
    $('#myModalAdd').modal('show')
  }

  vm.edit = function(item) {
    vm.app = angular.copy(item)
    delete vm.app.ts
    delete vm.app['ts-m']
    $('#myModalAdd').modal('show')
  }

  vm.create = function() {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }
    if (!vm.app.k) {
      swal('Please enter a Type', '', 'error')
      return
    }
    if (!vm.app['img-i']) {
      swal('Please enter an Icon', '', 'error')
      return
    }
    if (!vm.app['url-h']) {
      swal('Please enter an Home URL', '', 'error')
      return
    }

    CompatibleAppService.save(vm.app).then(
      function() {
        $('#myModalAdd').modal('hide')
        load(1)
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.update = function() {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }
    if (!vm.app.k) {
      swal('Please enter a Type', '', 'error')
      return
    }
    if (!vm.app['img-i']) {
      swal('Please enter an Icon', '', 'error')
      return
    }
    if (!vm.app['url-h']) {
      swal('Please enter an Home URL', '', 'error')
      return
    }

    CompatibleAppService.update(vm.app.id, vm.app).then(
      function() {
        $('#myModalAdd').modal('hide')
        load(1)
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          CompatibleAppService.remove(item.id).then(
            function() {
              $('#myModalAdd').modal('hide')
              load(1)
            },
            function(err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.loadImage = false
  vm.upload = function(item) {
    vm.loadImage = true
    UploadService.save('compatible_apps', vm.pathImg, 'image', item.id).then(function(fileName) {
      vm.loadImage = false
      item['img-i'] = fileName
    })
  }
}
